// assets
import { IconUsers,IconBoxMultiple2  } from '@tabler/icons';


// constant
const icons = {
    IconUsers,
    IconBoxMultiple2
};

// ==============================|| EXTRA PAGES MENU ITEMS ||============================== //

const odds = {
    id: 'odds',
    type: 'group',
    children: [
        {
            id: 'odds',
            title: 'Odds',
            type: 'collapse',
            icon: icons.IconBoxMultiple2 ,

            children: [
                {
                    id: 'addOdds',
                    title: 'Add Odds',
                    type: 'item',
                    url: '/odds/addOdds',
                    breadcrumbs: true
                },
                {
                    id: 'listOdds',
                    title: 'List Odds',
                    type: 'item',
                    url: '/odds/listOdds',
                    breadcrumbs: true
                }
            ]
        }
    ]
};

export default odds;
